import { useRef, type ComponentProps } from "react";
import { cn } from "@/lib/cn";
import {
  surfaceRoleAttributes,
  surfaceRoleClassName,
} from "./surface-contract";
import { useAutoResizeTextarea } from "./use-auto-resize-textarea";

type AutoResizeTextareaProps = ComponentProps<"textarea"> & {
  maxHeight?: number;
  appearance?: "field" | "plain";
};

export function AutoResizeTextarea({
  value,
  maxHeight = 160,
  appearance = "field",
  className,
  ...props
}: AutoResizeTextareaProps) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useAutoResizeTextarea(ref, value, maxHeight);

  return (
    <textarea
      ref={ref}
      value={value}
      rows={2}
      className={cn(
        appearance === "field" && surfaceRoleClassName("input"),
        appearance === "field"
          ? "block min-h-[72px] w-full resize-none rounded-control px-appkit-sm py-2 text-appkit-body text-primary placeholder:text-muted focus:border-accent focus:shadow-input-focus focus:outline-none"
          : "block w-full resize-none bg-transparent text-appkit-body text-primary placeholder:text-muted focus:outline-none",
        className,
      )}
      {...props}
      {...(appearance === "field"
        ? surfaceRoleAttributes("input", { nativeLevel: "child" })
        : {})}
    />
  );
}
